module.exports = "/_next/static/images/offline_product_tnc-d90bb3487d4bc806acd72e867206d563.svg";